'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.extendPropTypes = extendPropTypes;
exports.allValidators = allValidators;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * This is a workaround for AutoDocs, so we can apply custom propTypes validators with side-effects, and not affect the generated prop type.
 * If we had support for writing JSDoc for props with a `@type` tag, then we wouldn't need this.
 */
function extendPropTypes(Component, propTypes) {
  Component.propTypes = _extends({}, Component.propTypes, propTypes);
}

/**
 * Runs all validators.
 */
function allValidators() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return function (props, propName, componentName) {
    validators.forEach(function (validator) {
      _propTypes2.default.checkPropTypes(_defineProperty({}, propName, validator), props, propName, componentName);
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-style-react/dist/src/utils/propTypes.js
// module id = 1327
// module chunks = 0